import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, TextField } from "@mui/material";
import { setPropertiesFilters } from "../store/propertiesSlice";
import { selectPropertiesFilters } from "../store/propertiesSelectors";
import { NeighbourhoodInput } from "./NeighbourhoodInput";
import { SuburbInput } from "./SuburbInput";
import { CityInput } from "./CityInput";

export const PropertyFilters: React.FC = () => {
  const dispatch = useDispatch();
  const filters = useSelector(selectPropertiesFilters);

  const handleSearchChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(setPropertiesFilters({ search: event.target.value }));
    },
    [dispatch]
  );

  const handleNeighbourhoodChange = useCallback(
    (neighbourhood: string) => {
      dispatch(setPropertiesFilters({ neighbourhood }));
    },
    [dispatch]
  );

  const handleSuburbChange = useCallback(
    (suburb: string) => {
      dispatch(setPropertiesFilters({ suburb }));
    },
    [dispatch]
  );

  const handleCityChange = useCallback(
    (city: string) => {
      dispatch(setPropertiesFilters({ city }));
    },
    [dispatch]
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        mb: 2,
      }}
    >
      <TextField
        label="Search properties"
        value={filters.search}
        onChange={handleSearchChange}
        size="small"
        sx={{ minWidth: 300, maxWidth: 400 }}
        placeholder="Search by address, neighbourhood, suburb, city, or strata plan"
      />
      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
          alignItems: "flex-end",
        }}
      >
        <Box sx={{ minWidth: 200, maxWidth: 250 }}>
          <NeighbourhoodInput
            value={filters.neighbourhood}
            onChange={handleNeighbourhoodChange}
            size="small"
          />
        </Box>
        <Box sx={{ minWidth: 200, maxWidth: 250 }}>
          <SuburbInput
            value={filters.suburb}
            onChange={handleSuburbChange}
            size="small"
          />
        </Box>
        <Box sx={{ minWidth: 200, maxWidth: 250 }}>
          <CityInput
            value={filters.city}
            onChange={handleCityChange}
            size="small"
          />
        </Box>
      </Box>
    </Box>
  );
};
